import { render, staticRenderFns } from "./FormPilih.vue?vue&type=template&id=6b8d4a31&"
import script from "./FormPilih.vue?vue&type=script&lang=js&"
export * from "./FormPilih.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports